<template>
  <b-card
    :title="'장학 대상자'"
    tag="article"
    class="mb-2"
  >
    <p class="card-text">
      <b-row>
        <b-col md="2">
          <b-form-group
            name="typeSet"
            label="구분"
            label-for="type"
            :invalid-feedback="''"
            :valid-feedback="''"
          >
            <b-form-select
              v-model="donateItem.type"
              v-validate.initial="veeRequired"
              name="type"
              :state="isValid('type')"
              :disabled="freezing"
              :options="donateTypeOptions"
              @input="updateItem()"
            />
          </b-form-group>
        </b-col>
        <b-col
          v-if="donateItem.type === '지정'"
          sm="12"
          md="2"
        >
          <b-form-group
            name="relSet"
            label="장학대상자와의 관계"
            label-for="rel"
            :invalid-feedback="''"
            :valid-feedback="''"
          >
            <b-form-input
              v-model="donateItem.rel"
              v-validate.initial="veeRequired"
              name="rel"
              :state="isValid('rel')"
              placeholder="e.g.) 부서간사, 구역렘넌트 등"
              :disabled="freezing"
              @input="updateItem()"
            />
          </b-form-group>
        </b-col>
        <b-col
          sm="12"
          md="5"
        >
          <b-form-group
            name="targetSet"
            label="장학금을 전달할 개인, 부서 또는 분야"
            label-for="target"
            :invalid-feedback="''"
            :valid-feedback="''"
          >
            <b-form-input
              v-model="donateItem.target"
              v-validate.initial="veeRequired"
              name="target"
              :state="isValid('target')"
              placeholder="장학금을 전달할 대상을 작성해 주세요"
              :disabled="freezing"
              @input="updateItem()"
            />
          </b-form-group>
        </b-col>
        <b-col
          sm="12"
          md="3"
        >
          <b-form-group
            name="eachAmountSet"
            label="장학금(단위: 원)"
            label-for="eachAmount"
            :invalid-feedback="''"
            :valid-feedback="''"
          >
            <b-form-input
              v-model="donateItem.eachAmount"
              v-validate.initial="veeRequiredMoney"
              name="eachAmount"
              :state="isValid('eachAmount')"
              placeholder="금액을 입력해 주세요"
              :disabled="freezing"
              @input="updateItem()"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          v-if="!freezing && !disableDelete"
          md="12"
          class="text-right"
        >
          <b-button
            variant="danger"
            size="sm"
            @click="deleteItem()"
          >
            삭제
          </b-button>
        </b-col>
      </b-row>
    </p>
  </b-card>
</template>
<script>

export default {
  name: 'DonateItem',
  props: {
    donator: {
      type: String,
      required: true
    },
    donationNum: {
      type: Number,
      required: true
    },
    donateItem: {
      type: Object,
      required: true
    },
    readOnly: {
      type: Boolean,
      required: true
    },
    disableDelete: {
      type: Boolean,
      required: true
    }
  },
  data: function () {
    return {
      veeRequired: {
        required: true
      },
      veeRequiredMoney: {
        required: true,
        regex: /^([1-9][0-9]*)$/
      },
      donateTypeOptions: ['지정', '비지정']
    }
  },
  computed: {
    eachAmountCvt () {
      return Number(this.donateItem.eachAmount)
    },
    donationId () {
      return this.donator + '-' + this.donationNum
    },
    freezing () {
      return this.readOnly
    }
  },
  mounted () {
    this.$validator.reset()
  },
  methods: {
    isValid (name) {
      if (this.$validator.flags[name] === undefined) {
        return null
      } else if (!this.$validator.flags[name].validated) {
        return null
      } else {
        return this.$validator.flags[name].valid
      }
    },
    deleteItem () {
      this.$emit('deleteDonate', this.donationNum)
    },
    updateItem () {
      if (this.donateItem.target !== '' && Number(this.donateItem.eachAmount) > 0 && (this.donateItem.type === '비지정' || this.donateItem.rel !== '')) {
        this.donateItem.valid = true
      } else {
        this.donateItem.valid = false
      }
      this.$emit('updateDonate', this.donationNum, this.donateItem)
    }
  }
}
</script>

<style>
</style>
